import SearchAutocomplete from '@app/main/forms/components/SearchAutocomplete';
import { Input, Textarea } from '@mui/joy';

export type FormType =
    | 'string'
    | 'number'
    | 'date'
    | 'boolean'
    | 'text'
    | 'collaborators'
    | 'clubs';

type Props = {
    type: FormType;
    value: string;
    name: string;
    onChange: (value: any) => void;
};
const RenderFormType = ({ type, value, name, onChange }: Props) => {
    switch (type) {
        case 'string':
            return (
                <Input
                    size="sm"
                    type="text"
                    name={name}
                    value={value}
                    onChange={(e: any) => onChange(e.target.value)}
                />
            );
        case 'number':
            return (
                <Input
                    size="sm"
                    type="number"
                    name={name}
                    value={value}
                    onChange={(e: any) => onChange(e.target.value)}
                />
            );
        case 'date':
            return (
                <Input
                    size="sm"
                    type="date"
                    name={name}
                    value={value}
                    onChange={(e: any) => onChange(e.target.value)}
                />
            );
        case 'boolean':
            return (
                <Input
                    type="checkbox"
                    name={name}
                    value={value}
                    onChange={(e: any) => onChange(e.target.value)}
                />
            );
        case 'text':
            return (
                <Textarea
                    size="sm"
                    name={name}
                    value={value}
                    onChange={(e: any) => onChange(e.target.value)}
                />
            );
        case 'collaborators':
            return (
                <SearchAutocomplete
                    apiUrl={'/users'}
                    keyDisplay="ref"
                    dbSendKey="ref"
                    onChange={onChange}
                    initialId={null}
                />
            );
        case 'clubs':
            return (
                <SearchAutocomplete
                    apiUrl={'/mandats'}
                    keyDisplay="ref"
                    dbSendKey="ref"
                    onChange={onChange}
                    initialId={null}
                />
            );
        default:
            return null;
    }
};

export default RenderFormType;
